<div class="form-block" style="padding: 20px; border: 1px solid rgba(0, 0, 0, 12.5%); background-color: #fafafa">
  <gpf-enrichment-models [selectedDatasetId]="selectedDatasetId"></gpf-enrichment-models>
</div>
